import CalculatorView from '@app/Calculator/View'
import CalculatorInliner from '@app/Calculator/Inliner'

export default function install(Vue) {
  Vue.component('CalculatorView', CalculatorView)
  Vue.component('CalculatorInliner', CalculatorInliner)
}
